module.exports = __webpack_public_path__ + "img/star_filled.5a060419.svg";